<div class="min-w-[50rem]">
    <div class="flex flex-col">
        <p class="text-lg font-bold pb-4 text-sigecom-dark-gray">
            Informações do participante:
        </p>
        <sigecom-tabs [activeTabBorderClass]="'border-2 shadow-none border-[#ECEDF2]'"
            [tabs]="['Dados Cadastrais', 'Contatos', 'Endereço', 'Documentos']"
            [(selectedTab)]="abaSelecionadaParticipantView">
        </sigecom-tabs>
    </div>

    <div class="border-solid border-2 p-2 rounded-b-lg rounded-r-lg">

        <!-- Dados Cadastrais -->
        <div *ngIf="abaSelecionadaParticipantView === 'Dados Cadastrais'" class="text-[#787878] gap-2">
            <fa-icon icon="user-circle" class="text-[5rem] text-sigecom-gray"></fa-icon>
            <div [class]="dataViewStyle">
                <p class="font-bold text-[#787878]">
                    {{ userEvent?.usuTxNome || 'Nome não informado' }}
                </p>
                <div class="text-[#787878] font-semibold">
                    <p>
                        <span>Data de Nascimento: </span>
                        {{ userEvent?.usuDtNascimento ? (userEvent!.usuDtNascimento | date: 'dd/MM/yyyy') : 'Não informada' }}
                    </p>
                    <p><span>Sexo: </span> {{ userEvent?.usuTxSexo || 'Não informado' }}</p>
                    <p><span>Peso: </span> {{ userEvent?.usuNrPeso ? userEvent!.usuNrPeso + 'Kg' : 'Não informado' }}
                    </p>
                    <p><span>Altura: </span> {{ userEvent?.usuNrAltura || 'Não informada' }}</p>
                    <p><span>Código INEP: </span> {{ userEvent?.usuTxCodigoIep || 'Não informado' }}</p>
                    <p><span>Lado dominante: </span> {{ userEvent?.usuTxLadoDominante || 'Não informado' }}</p>
                    <p><span>Instituição: </span> {{ iTeachingInstitutionDto?.insTxNome || 'Sem Instituição' }}</p>
                    <p *ngIf="iTeachingInstitutionDto?.insBlPrivada"><span class="font-bold">Instituição privada:
                        </span> {{ iTeachingInstitutionDto?.insBlPrivada ? 'Sim' : 'Não' }}</p>
                    <p><span>Federação: </span>
                        {{ iTeachingInstitutionDto?.insObjFederacao?.fedTxNome || 'SEM FEDERAÇÃO' }}
                    </p>
                </div>
            </div>
        </div>

        <!-- Contatos -->
        <div *ngIf="abaSelecionadaParticipantView === 'Contatos'" class="p-2">
            <div *ngFor="let contact of userContact?.content; let i = index">
                <p class="text-[#787878] font-semibold"><span>{{ contact?.conTxTipo || 'Tipo não informado' }}:</span>
                    {{ contact?.conTxContato || 'Não informado' }}</p>
            </div>
        </div>

        <!-- Endereço -->
        <div *ngIf="abaSelecionadaParticipantView === 'Endereço'">
            <div class="text-[#787878] font-semibold">
                <p><span>Logradouro:</span> {{ userPublicPlace?.logTxLogradouro || 'Não informado' }}</p>
                <p><span>Número:</span> {{ userPublicPlace?.logNrNumero || 'SN' }}</p>
                <p><span>Complemento:</span> {{ userPublicPlace?.logTxComplemento || 'Não informado' }}</p>
                <p><span>Bairro:</span> {{ userPublicPlace?.logTxBairro || 'Não informado' }}</p>
                <p><span>CEP:</span> {{ userPublicPlace?.logTxCep || 'Não informado' }}</p>
                <p><span>Cidade:</span> {{ userDataCity?.cidTxDescricao || 'Não informada' }}</p>
                <p>
                    <span>Estado:</span>
                    {{ userDataCity?.cidObjEstado?.estTxDescricao || 'Não informado' }} -
                    {{ userDataCity?.cidObjEstado?.estObjPais?.paiTxDescricaoPt || 'País não informado' }}
                </p>
            </div>
        </div>

        <!-- Documentos -->
        <div *ngIf="abaSelecionadaParticipantView === 'Documentos'">
            <div *ngFor="let document of userDocument?.content"
                class="text-[#787878] font-semibold flex gap-1 flex-row">
                <span>Documento: </span>
                <span>{{ document?.docTxTipo || 'Tipo não informado' }}:</span>
                <p>Nº {{ document?.docTxDocumento || 'Não informado' }}</p>
            </div>
        </div>

    </div>

    <p *ngIf="!atlNrId" class="text-red-600 font-semibold mt-2">Nenhum participante selecionado</p>
</div>